export default {
  message: 'The maximum number of shipments you can export at any one time is 120,000. Use filters to reduce the number of shipments.',
  limit: 120000,
};
